<template>
  <section class="icon-picker">
    <div class="wrap" @click="close"></div>
    <div class="icon-OuterWrap">
      <v-icon
        v-if="withTimesButton"
        @click="close"
        class="icon icon-close-modal"
        scale="1.5"
        name="times"
      />

      <div class="icons-container">
        <div class="grid-container grid-col-5">
          <div
            class="icon-container"
            v-for="icon in newIconsArray"
            :key="icon.value"
            @click="selectIcon(icon)"
          >
            <v-icon class="icon" :name="icon.value" scale="2.5" />
          </div>
        </div>
      </div>

      <!-- Button Container
      <div class="button-container">
        <button class="button-neutral" @click="close()">Cancel</button>
      </div> -->
    </div>
  </section>
</template>

<script>
export default {
  props: {
    withTimesButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newIconsArray: [
        // Commented out old icons to avoid duplicates - old ones should be present in new set

        // { text: "bed", value: "bed" },
        // { text: "regular/map", value: "regular/map" },
        // { text: "wifi", value: "wifi" },
        // { text: "hotel", value: "hotel" },
        // { text: "utensils", value: "utensils" },
        // { text: "bicycle", value: "bicycle" },
        // { text: "car", value: "car" },
        // { text: "heart", value: "heart" },
        // { text: "train", value: "train" },
        // { text: "shopping-bag", value: "shopping-bag" },
        // { text: "map-marker", value: "map-marker" },
        // { text: "street-view", value: "street-view" },
        // { text: "map-pin", value: "map-pin" },
        // { text: "info", value: "info" },
        // { text: "suitcase", value: "suitcase" },
        // { text: "book", value: "book" },
        // { text: "music", value: "music" },
        // { text: "map-signs", value: "map-signs" },
        // { text: "check-circle", value: "check-circle" },
        // { text: "star", value: "star" },
        // { text: "shopping-basket", value: "shopping-basket" },
        // { text: "tree", value: "tree" },
        // { text: "binoculars", value: "binoculars" },
        // { text: "hourglass", value: "hourglass" },
        // { text: "heartbeat", value: "heartbeat" },
        // { text: "calendar", value: "calendar" },
        // { text: "check", value: "check" },
        // { text: "users", value: "users" },
        // { text: "bell", value: "bell" },

        // 389 new icons
        { text: "calendar", value: "calendar" },
        { text: "street-view", value: "street-view" },
        { text: "bed", value: "bed" },
        { text: "regular/map", value: "regular/map" },
        { text: "address-card", value: "address-card" },
        { text: "ambulance", value: "ambulance" },
        { text: "anchor", value: "anchor" },
        { text: "archway", value: "archway" },
        { text: "at", value: "at" },
        { text: "atlas", value: "atlas" },
        { text: "award", value: "award" },
        { text: "baby", value: "baby" },
        { text: "baby-carriage", value: "baby-carriage" },
        { text: "balance-scale", value: "balance-scale" },
        { text: "ban", value: "ban" },
        { text: "band-aid", value: "band-aid" },
        { text: "barcode", value: "barcode" },
        { text: "basketball-ball", value: "basketball-ball" },
        { text: "bath", value: "bath" },
        { text: "beer", value: "beer" },
        { text: "bell", value: "bell" },
        { text: "bell-slash", value: "bell-slash" },
        { text: "bicycle", value: "bicycle" },
        { text: "biking", value: "biking" },
        { text: "binoculars", value: "binoculars" },
        { text: "birthday-cake", value: "birthday-cake" },
        { text: "blind", value: "blind" },
        { text: "bolt", value: "bolt" },
        { text: "bomb", value: "bomb" },
        { text: "bone", value: "bone" },
        { text: "book", value: "book" },
        { text: "book-open", value: "book-open" },
        { text: "book-reader", value: "book-reader" },
        { text: "bookmark", value: "bookmark" },
        { text: "bowling-ball", value: "bowling-ball" },
        { text: "box", value: "box" },
        { text: "box-open", value: "box-open" },
        { text: "brain", value: "brain" },
        { text: "bread-slice", value: "bread-slice" },
        { text: "briefcase", value: "briefcase" },
        { text: "briefcase-medical", value: "briefcase-medical" },
        { text: "broom", value: "broom" },
        { text: "building", value: "building" },
        { text: "bullhorn", value: "bullhorn" },
        { text: "bullseye", value: "bullseye" },
        { text: "burn", value: "burn" },
        { text: "bus", value: "bus" },
        { text: "bus-alt", value: "bus-alt" },
        { text: "business-time", value: "business-time" },
        { text: "calculator", value: "calculator" },
        { text: "calendar-alt", value: "calendar-alt" },
        { text: "calendar-check", value: "calendar-check" },
        { text: "calendar-plus", value: "calendar-plus" },
        { text: "camera", value: "camera" },
        { text: "campground", value: "campground" },
        { text: "candy-cane", value: "candy-cane" },
        { text: "capsules", value: "capsules" },
        { text: "car", value: "car" },
        { text: "car-side", value: "car-side" },
        //{ text: "caravan", value: "caravan" },
        { text: "carrot", value: "carrot" },
        { text: "cart-arrow-down", value: "cart-arrow-down" },
        { text: "cart-plus", value: "cart-plus" },
        { text: "cash-register", value: "cash-register" },
        { text: "cat", value: "cat" },
        { text: "certificate", value: "certificate" },
        { text: "chair", value: "chair" },
        { text: "charging-station", value: "charging-station" },
        { text: "chart-line", value: "chart-line" },
        { text: "chart-pie", value: "chart-pie" },
        { text: "check", value: "check" },
        { text: "check-circle", value: "check-circle" },
        { text: "cheese", value: "cheese" },
        { text: "child", value: "child" },
        { text: "church", value: "church" },
        { text: "city", value: "city" },
        { text: "clinic-medical", value: "clinic-medical" },
        { text: "clipboard-check", value: "clipboard-check" },
        { text: "clipboard-list", value: "clipboard-list" },
        { text: "clock", value: "clock" },
        { text: "cloud", value: "cloud" },
        { text: "cloud-moon", value: "cloud-moon" },
        { text: "cloud-rain", value: "cloud-rain" },
        { text: "cloud-showers-heavy", value: "cloud-showers-heavy" },
        { text: "cloud-sun", value: "cloud-sun" },
        { text: "cloud-sun-rain", value: "cloud-sun-rain" },
        { text: "cocktail", value: "cocktail" },
        { text: "coffee", value: "coffee" },
        { text: "cog", value: "cog" },
        { text: "coins", value: "coins" },
        { text: "comment", value: "comment" },
        { text: "comment-slash", value: "comment-slash" },
        { text: "comments", value: "comments" },
        { text: "compass", value: "compass" },
        { text: "compress", value: "compress" },
        { text: "concierge-bell", value: "concierge-bell" },
        { text: "cookie", value: "cookie" },
        { text: "couch", value: "couch" },
        { text: "credit-card", value: "credit-card" },
        { text: "crow", value: "crow" },
        { text: "crown", value: "crown" },
        { text: "cut", value: "cut" },
        { text: "desktop", value: "desktop" },
        { text: "dice", value: "dice" },
        { text: "dog", value: "dog" },
        { text: "dollar-sign", value: "dollar-sign" },
        { text: "dolly", value: "dolly" },
        { text: "donate", value: "donate" },
        { text: "door-closed", value: "door-closed" },
        { text: "door-open", value: "door-open" },
        { text: "dove", value: "dove" },
        { text: "download", value: "download" },
        { text: "drum", value: "drum" },
        { text: "drumstick-bite", value: "drumstick-bite" },
        { text: "dumbbell", value: "dumbbell" },
        { text: "dumpster", value: "dumpster" },
        { text: "edit", value: "edit" },
        { text: "egg", value: "egg" },
        { text: "envelope", value: "envelope" },
        { text: "envelope-open", value: "envelope-open" },
        { text: "eraser", value: "eraser" },
        { text: "euro-sign", value: "euro-sign" },
        { text: "exchange-alt", value: "exchange-alt" },
        { text: "exclamation", value: "exclamation" },
        { text: "exclamation-circle", value: "exclamation-circle" },
        { text: "exclamation-triangle", value: "exclamation-triangle" },
        { text: "expand", value: "expand" },
        { text: "eye", value: "eye" },
        { text: "eye-dropper", value: "eye-dropper" },
        { text: "eye-slash", value: "eye-slash" },
        { text: "fan", value: "fan" },
        //{ text: "faucet", value: "faucet" },
        { text: "fax", value: "fax" },
        { text: "feather", value: "feather" },
        { text: "female", value: "female" },
        { text: "film", value: "film" },
        { text: "fingerprint", value: "fingerprint" },
        { text: "fire", value: "fire" },
        { text: "fire-extinguisher", value: "fire-extinguisher" },
        { text: "first-aid", value: "first-aid" },
        { text: "fish", value: "fish" },
        { text: "flag", value: "flag" },
        { text: "flask", value: "flask" },
        { text: "football-ball", value: "football-ball" },
        { text: "futbol", value: "futbol" },
        { text: "gamepad", value: "gamepad" },
        { text: "gas-pump", value: "gas-pump" },
        { text: "gem", value: "gem" },
        { text: "ghost", value: "ghost" },
        { text: "gift", value: "gift" },
        { text: "gifts", value: "gifts" },
        { text: "glass-cheers", value: "glass-cheers" },
        { text: "glass-martini", value: "glass-martini" },
        { text: "glass-martini-alt", value: "glass-martini-alt" },
        { text: "glass-whiskey", value: "glass-whiskey" },
        { text: "glasses", value: "glasses" },
        { text: "globe", value: "globe" },
        { text: "golf-ball", value: "golf-ball" },
        { text: "graduation-cap", value: "graduation-cap" },
        { text: "grin", value: "grin" },
        { text: "grin-beam", value: "grin-beam" },
        { text: "grin-squint", value: "grin-squint" },
        { text: "grin-stars", value: "grin-stars" },
        { text: "guitar", value: "guitar" },
        { text: "hamburger", value: "hamburger" },
        { text: "hammer", value: "hammer" },
        { text: "hands", value: "hands" },
        { text: "hands-helping", value: "hands-helping" },
        // { text: "hands-wash", value: "hands-wash" },
        { text: "handshake", value: "handshake" },
        { text: "hashtag", value: "hashtag" },
        { text: "hat-cowboy", value: "hat-cowboy" },
        { text: "hat-wizard", value: "hat-wizard" },
        { text: "headphones-alt", value: "headphones-alt" },
        { text: "heart", value: "heart" },
        { text: "heartbeat", value: "heartbeat" },
        { text: "helicopter", value: "helicopter" },
        { text: "highlighter", value: "highlighter" },
        { text: "hiking", value: "hiking" },
        { text: "hippo", value: "hippo" },
        { text: "history", value: "history" },
        { text: "home", value: "home" },
        { text: "horse", value: "horse" },
        { text: "horse-head", value: "horse-head" },
        { text: "hospital", value: "hospital" },
        { text: "hot-tub", value: "hot-tub" },
        { text: "hotdog", value: "hotdog" },
        { text: "hotel", value: "hotel" },
        { text: "hourglass", value: "hourglass" },
        { text: "hourglass-end", value: "hourglass-end" },
        { text: "hourglass-half", value: "hourglass-half" },
        // { text: "house-user", value: "house-user" },
        { text: "ice-cream", value: "ice-cream" },
        { text: "icons", value: "icons" },
        { text: "id-badge", value: "id-badge" },
        { text: "igloo", value: "igloo" },
        { text: "image", value: "image" },
        { text: "images", value: "images" },
        { text: "industry", value: "industry" },
        { text: "infinity", value: "infinity" },
        { text: "info", value: "info" },
        { text: "info-circle", value: "info-circle" },
        { text: "key", value: "key" },
        { text: "keyboard", value: "keyboard" },
        { text: "landmark", value: "landmark" },
        { text: "language", value: "language" },
        { text: "laptop", value: "laptop" },
        { text: "laugh", value: "laugh" },
        { text: "laugh-beam", value: "laugh-beam" },
        { text: "leaf", value: "leaf" },
        { text: "lemon", value: "lemon" },
        { text: "life-ring", value: "life-ring" },
        { text: "lightbulb", value: "lightbulb" },
        { text: "link", value: "link" },
        { text: "list", value: "list" },
        { text: "location-arrow", value: "location-arrow" },
        { text: "lock", value: "lock" },
        { text: "lock-open", value: "lock-open" },
        { text: "luggage-cart", value: "luggage-cart" },
        { text: "magic", value: "magic" },
        { text: "mail-bulk", value: "mail-bulk" },
        { text: "male", value: "male" },
        { text: "map", value: "map" },
        { text: "map-marked", value: "map-marked" },
        { text: "map-marked-alt", value: "map-marked-alt" },
        { text: "map-marker", value: "map-marker" },
        { text: "map-marker-alt", value: "map-marker-alt" },
        { text: "map-pin", value: "map-pin" },
        { text: "map-signs", value: "map-signs" },
        { text: "marker", value: "marker" },
        { text: "medal", value: "medal" },
        { text: "microphone", value: "microphone" },
        { text: "minus-cicle", value: "minus-circle" },
        { text: "mobile", value: "mobile" },
        { text: "mobile-alt", value: "mobile-alt" },
        { text: "money-bill", value: "money-bill" },
        { text: "monument", value: "monument" },
        { text: "moon", value: "moon" },
        { text: "mosque", value: "mosque" },
        { text: "motorcycle", value: "motorcycle" },
        { text: "mountain", value: "mountain" },
        { text: "mug-hot", value: "mug-hot" },
        { text: "music", value: "music" },
        { text: "newspaper", value: "newspaper" },
        { text: "oil-can", value: "oil-can" },
        { text: "paint-brush", value: "paint-brush" },
        { text: "palette", value: "palette" },
        { text: "paper-plane", value: "paper-plane" },
        { text: "paperclip", value: "paperclip" },
        { text: "parking", value: "parking" },
        { text: "passport", value: "passport" },
        { text: "paw", value: "paw" },
        { text: "pen", value: "pen" },
        { text: "pencil-alt", value: "pencil-alt" },
        // { text: "people-arrow", value: "people-arrow" },
        { text: "people-carry", value: "people-carry" },
        { text: "percent", value: "percent" },
        { text: "percentage", value: "percentage" },
        { text: "phone", value: "phone" },
        { text: "phone-alt", value: "phone-alt" },
        { text: "phone-slash", value: "phone-slash" },
        { text: "phone-square", value: "phone-square" },
        { text: "phone-square-alt", value: "phone-square-alt" },
        { text: "phone-volume", value: "phone-volume" },
        { text: "photo-video", value: "photo-video" },
        { text: "piggy-bank", value: "piggy-bank" },
        { text: "pills", value: "pills" },
        { text: "pizza-slice", value: "pizza-slice" },
        { text: "plane", value: "plane" },
        { text: "plane-arrival", value: "plane-arrival" },
        { text: "plane-departure", value: "plane-departure" },
        // { text: "plane-slash", value: "plane-slash" },
        { text: "plug", value: "plug" },
        // { text: "plus-cicle", value: "plus-cicle" },
        { text: "podcast", value: "podcast" },
        { text: "portrait", value: "portrait" },
        { text: "pound-sign", value: "pound-sign" },
        { text: "power-off", value: "power-off" },
        { text: "print", value: "print" },
        // { text: "pump-soap", value: "pump-soap" },
        { text: "puzzle-piece", value: "puzzle-piece" },
        { text: "qrcode", value: "qrcode" },
        { text: "question", value: "question" },
        { text: "question-circle", value: "question-circle" },
        { text: "radiation", value: "radiation" },
        { text: "rainbow", value: "rainbow" },
        { text: "random", value: "random" },
        { text: "receipt", value: "receipt" },
        { text: "recycle", value: "recycle" },
        { text: "redo", value: "redo" },
        { text: "restroom", value: "restroom" },
        { text: "road", value: "road" },
        { text: "robot", value: "robot" },
        { text: "rocket", value: "rocket" },
        { text: "route", value: "route" },
        { text: "ruler", value: "ruler" },
        { text: "running", value: "running" },
        { text: "satellite-dish", value: "satellite-dish" },
        { text: "save", value: "save" },
        { text: "school", value: "school" },
        { text: "scroll", value: "scroll" },
        { text: "sd-card", value: "sd-card" },
        { text: "search", value: "search" },
        { text: "search-location", value: "search-location" },
        { text: "search-dollar", value: "search-dollar" },
        { text: "seeding", value: "seedling" },
        { text: "shield-alt", value: "shield-alt" },
        { text: "ship", value: "ship" },
        { text: "shipping-fast", value: "shipping-fast" },
        { text: "shoe-prints", value: "shoe-prints" },
        { text: "shopping-bag", value: "shopping-bag" },
        { text: "shopping-basket", value: "shopping-basket" },
        { text: "shopping-cart", value: "shopping-cart" },
        { text: "shower", value: "shower" },
        { text: "shuttle-van", value: "shuttle-van" },
        { text: "sign", value: "sign" },
        { text: "sign-language", value: "sign-language" },
        { text: "signal", value: "signal" },
        { text: "signature", value: "signature" },
        { text: "sim-card", value: "sim-card" },
        { text: "skating", value: "skating" },
        { text: "skiing", value: "skiing" },
        { text: "skiing-nordic", value: "skiing-nordic" },
        { text: "skull-crossbones", value: "skull-crossbones" },
        { text: "smoking", value: "smoking" },
        { text: "smoking-ban", value: "smoking-ban" },
        { text: "sms", value: "sms" },
        { text: "snowboarding", value: "snowboarding" },
        { text: "snowflake", value: "snowflake" },
        { text: "snowman", value: "snowman" },
        { text: "socks", value: "socks" },
        { text: "spa", value: "spa" },
        { text: "star", value: "star" },
        { text: "store", value: "store" },
        { text: "store-alt", value: "store-alt" },
        { text: "subway", value: "subway" },
        { text: "suitcase", value: "suitcase" },
        { text: "suitcase-rolling", value: "suitcase-rolling" },
        { text: "sun", value: "sun" },
        { text: "swimmer", value: "swimmer" },
        { text: "swimming-pool", value: "swimming-pool" },
        { text: "sync", value: "sync" },
        { text: "table-tennis", value: "table-tennis" },
        { text: "tablet", value: "tablet" },
        { text: "tablet-alt", value: "tablet-alt" },
        { text: "tag", value: "tag" },
        { text: "tags", value: "tags" },
        { text: "taxi", value: "taxi" },
        { text: "temperature-high", value: "temperature-high" },
        { text: "theater-masks", value: "theater-masks" },
        { text: "thumbs-up", value: "thumbs-up" },
        { text: "ticket-alt", value: "ticket-alt" },
        { text: "times", value: "times" },
        { text: "toilet", value: "toilet" },
        { text: "toilet-paper", value: "toilet-paper" },
        { text: "tools", value: "tools" },
        { text: "tooth", value: "tooth" },
        { text: "traffic-light", value: "traffic-light" },
        { text: "train", value: "train" },
        { text: "tram", value: "tram" },
        { text: "trash", value: "trash" },
        { text: "tree", value: "tree" },
        { text: "trophy", value: "trophy" },
        { text: "truck", value: "truck" },
        { text: "truck-moving", value: "truck-moving" },
        { text: "tshirt", value: "tshirt" },
        { text: "tv", value: "tv" },
        { text: "umbrella", value: "umbrella" },
        { text: "umbrella-beach", value: "umbrella-beach" },
        { text: "universal-access", value: "universal-access" },
        { text: "university", value: "university" },
        { text: "unlock", value: "unlock" },
        { text: "user", value: "user" },
        { text: "user-check", value: "user-check" },
        { text: "user-cicle", value: "user-circle" },
        { text: "user-friends", value: "user-friends" },
        { text: "user-tie", value: "user-tie" },
        { text: "users", value: "users" },
        { text: "utensils", value: "utensils" },
        { text: "video", value: "video" },
        { text: "volleyball-ball", value: "volleyball-ball" },
        { text: "walking", value: "walking" },
        { text: "wallet", value: "wallet" },
        { text: "warehouse", value: "warehouse" },
        { text: "water", value: "water" },
        { text: "weight-hanging", value: "weight-hanging" },
        { text: "wheelchair", value: "wheelchair" },
        { text: "wifi", value: "wifi" },
        { text: "wind", value: "wind" },
        { text: "wine-bottle", value: "wine-bottle" },
        { text: "wine-glass", value: "wine-glass" },
        { text: "wine-glass-alt", value: "wine-glass-alt" },
        { text: "wrench", value: "wrench" },

        { text: "brands/tripadvisor", value: "brands/tripadvisor" },
        { text: "brands/instagram", value: "brands/instagram" },
        { text: "brands/facebook-f", value: "brands/facebook-f" },
        { text: "brands/linkedin-in", value: "brands/linkedin-in" },
        { text: "brands/facebook", value: "brands/facebook" },
        { text: "regular/heart", value: "regular/heart" },
        { text: "regular/thumbs-up", value: "regular/thumbs-up" },
        { text: "regular/sun", value: "regular/sun" },
        { text: "brands/facebook-square", value: "brands/facebook-square" },
        { text: "brands/youtube", value: "brands/youtube" },
        { text: "glass-martini", value: "glass-martini" },
        { text: "regular/newspaper", value: "regular/newspaper" },
        { text: "brands/gratipay", value: "brands/gratipay" },
        { text: "regular/smile", value: "regular/smile" },
      ],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    selectIcon(icon) {
      this.$emit("selectedNewIcon", icon.value);
      this.close();
    },
  },
};
</script>

<style scoped>
.icon-close-modal {
  position: relative;
  bottom: 1rem;
  left: 11rem;
  cursor: pointer;
}
.wrap {
  top: 0;
  bottom: 0;
  left: 0px;
  right: 0px;
  height: 100%;
  width: 100%;
  position: absolute;
}

.icon-picker {
  margin-left: 196px;
  margin-top: -116px;
}

.icon-OuterWrap {
  z-index: 999;
  position: absolute;
  width: 416px;
  background-color: var(--light);
  border-radius: 8px;
  padding: 16px 4px 16px 16px;
  border: solid 1px var(--grey);
}

.grid-container {
  grid-gap: 11px;
}

.icons-container {
  height: 364px;
  overflow-x: hidden;
}

.icon-container {
  border: 1px solid var(--grey);
  position: relative;
  height: 64px;
  width: 64px;
  cursor: pointer;
  border-radius: var(--border-radius);
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  margin: auto;
  margin-top: 12px;
}
</style>
